import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SecurityService, StorageService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';
import { IFeedback, PlatForm } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'medpt-feedback-bot',
    templateUrl: './feedback-bot.component.html',
    styleUrls: ['./feedback-bot.component.scss'],
    standalone: false
})
export class FeedbackBotComponent implements OnInit {
  cdnEndPoint = environment.cdnEndPoint;
  isFeedbackOpen = false;
  feedbackForm!: FormGroup;
  selectedCategory = '';
  isSubmitting = false;
  isSubmitted = false;
  
  categories = [
    'Compliment',
    'Improvement suggestion',
    'Error or Technical difficulty',
    'Other'
  ];

  constructor(
    private fb: FormBuilder,
    private securityService: SecurityService,
    private storageService: StorageService
  ) { }

  async ngOnInit(): Promise<void> {

      
    try {
      // Force global execution by injecting script tags
      await this.loadExternalScript('/assets/botchat/botchat-es5.js');
      await this.loadExternalScript('/assets/botchat/webchat-es5.js');
      console.log('BotChat scripts globally loaded');
    } catch (e) {
      console.error('BotChat load failed', e);
    }
    this.feedbackForm = this.fb.group({
      comment: ['', [Validators.required, Validators.maxLength(250)]]
    });
  }

  openFeedbackWindow(): void {
    this.isFeedbackOpen = true;
    this.selectedCategory = '';
    this.isSubmitted = false;
    this.feedbackForm.reset();
  }

  closeFeedbackWindow(): void {
    this.isFeedbackOpen = false;
    this.selectedCategory = '';
    this.isSubmitted = false;
    this.feedbackForm.reset();
  }

  selectCategory(category: string): void {
    this.selectedCategory = category;
  }

  submitFeedback(): void {
    if (!this.selectedCategory || this.feedbackForm.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    const currentUser = this.securityService.currentUserValue;

    const feedback: IFeedback = {
      Category: this.selectedCategory,
      Comment: this.feedbackForm.get('comment')?.value || '',
      Email: currentUser?.UserName || '',
      Feature: this.getProductContextOrFeature('feature'),
      Product: Helpers.getPlatformId() == PlatForm.TriPort ? 'TriPort' : 'CloudPort',
      FirstName: currentUser?.FirstName || '',
      LastName: currentUser?.LastName || '',
      ProductContext: this.getProductContextOrFeature('productcontext'),
      Environment: environment.production ? 'Prod' : 'Dev'
    };

    this.storageService.InsertFeedback(feedback).then(
      () => {
        this.isSubmitting = false;
        this.isSubmitted = true;
        setTimeout(() => this.closeFeedbackWindow(), 3000);
      },
      (err) => {
        this.isSubmitting = false;
        console.error('Failed to submit feedback:', err);
      }
    );
  }

  private getProductContextOrFeature(type: string): string {
    const locationPathname = window.location.pathname.split('/');
    const featurePath: string[] = locationPathname.filter((val: string) => val !== '');
    let productContext = '';
    if (featurePath.length > 0) {
      if (featurePath[0].toLowerCase() === 'dashboard') {
        productContext = featurePath[0];
      } else {
        productContext = featurePath[1] || '';
        if (featurePath.length > 2) {
          productContext = productContext + '/' + featurePath[2];
        }
      }
    }
    if (type === 'productcontext') {
      return productContext;
    } else {
      return featurePath[featurePath.length - 1] || '';
    }
  }
   private loadExternalScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Check if already loaded
      if (document.querySelector(`script[src="${url}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);
      document.body.appendChild(script);
    });
  }
}
